import React from 'react';
import { PropTypes as T } from 'prop-types';
import { FormGroup } from 'reactstrap';

import Parcel from 'app/models/parcel';

import ColFormLabel from 'app/components/bootstrap/col_form_label';
import Base from 'app/components/model_forms/base';
import BoundInput from 'app/components/forms/input/bound_input';
import FormRow from 'app/components/bootstrap/form_row';

export default class ParcelForm extends Base {
  static propTypes = {
    model: T.instanceOf(Parcel).isRequired,
  }

  render() {
    const { model } = this.props;

    return (
      <div>
        <FormGroup>
          <ColFormLabel>
            Predefined Package{' '}
            <a
              href="https://www.easypost.com/docs/api.html#predefined-packages"
              className="fa fa-info-circle"
              target="_blank"
              rel="noopener noreferrer"
            />
          </ColFormLabel>

          <BoundInput type="text" property="predefined_package" model={model} />
        </FormGroup>

        <hr />

        <FormRow>
          <FormGroup className="col-md-3">
            <ColFormLabel>Length (inches)</ColFormLabel>
            <BoundInput type="number" property="length" model={model} />
          </FormGroup>

          <FormGroup className="col-md-3">
            <ColFormLabel>Width (inches)</ColFormLabel>
            <BoundInput type="number" property="width" model={model} />
          </FormGroup>

          <FormGroup className="col-md-3">
            <ColFormLabel>Height (inches)</ColFormLabel>
            <BoundInput type="number" property="height" model={model} />
          </FormGroup>

          <FormGroup className="col-md-3">
            <ColFormLabel>Weight (ounces)</ColFormLabel>
            <BoundInput type="number" property="weight" model={model} />
          </FormGroup>
        </FormRow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/model_forms/parcel/index.jsx